export default __webpack_public_path__ + "static/media/LogoAriston.f82fc855.jpg";